import { useNavigate } from "react-router-dom";
import { Page } from "../Components/page/Page";
import { useTreasuryClient } from "../lib/client";
import { Labelled } from "../Components";
import Title from "../Components/page/Title";
import { ButtonCancel, ButtonOk } from "../Components/buttons";
import { useMutation } from "@tanstack/react-query";
import { useState } from "react";
import { useBalance } from "../lib/balance";
import TwinUrlInput from "../Components/TwinUrlInput.js";

export default function SendTDN() {
  const navigate = useNavigate();

  const treasury = useTreasuryClient();
  if (!treasury.isPurchaser) {
    navigate("/home");
  }

  const { data: dq } = useBalance(treasury.tdnHash);

  const { mutate: createPurchase } = useMutation({
    mutationFn: async function submitTdnPurchase(purchase) {
      return await treasury.createPurchase(purchase)
    },
    onSuccess: function createPurchaseSuccessFn(data) {
      navigate(`/purchase/${data.id}`);
    },
    onError: function createPurchaseErrorFn(error) {
      console.error(error);
    }
  })

  function submitTransfer(e) {
    e.preventDefault();
    const formData = new FormData(e.target);
    const purchase = {
      destination: formData.get("twin-url"),
      expectedValue: (transferAmountInput),
      paidValue: Number(formData.get("amount-paid")),
      paidValueUnits: formData.get("currency"),
      paymentReceipt: JSON.stringify({
        type: formData.get("receipt-type"),
        notes: formData.get("receipt-details")
      })
    };
    createPurchase(purchase);
  }

  const [ transferAmountInput, setTransferAmountInput ] = useState(0);

  return <Page>
    <div className="flex flex-row justify-center w-full mt-10">
      <div className="flex flex-col w-full lg:w-1/2 md:w-2/3 sm:w-full gap-3">

        <Title>CREATE PURCHASE RECORD AND SEND NOTES</Title>

        <form className="flex flex-col gap-3" onSubmit={submitTransfer}>
          <TwinUrlInput
            name="twin-url"
            required
            placeholder="Input twin URL" />

          <div className="flex flex-row justify-stretch gap-2">
            <Labelled label="Paid amount" className="w-full">
              <input
                name="amount-paid"
                type="number"
                max={treasury.tdnPurchaseMax}
                min={treasury.tdnPurchaseMin}
                step={10**-dq?.displayPrecision || 1}
                required
                onChange={(e) => setTransferAmountInput(Number(e.target.value)*treasury.tdnPurchasePrice)}
                placeholder={`Paid amount ${treasury.tdnPurchaseMin} to ${treasury.tdnPurchaseMax}`}
                className="w-full px-2 py-1 border rounded disabled:bg-zinc-100 disabled:text-zinc-400 invalid:text-error"
              />
            </Labelled>

            <Labelled label="Currency">
              <select
                name="currency"
                className="w-fit px-2 py-[0.37rem] border rounded disabled:bg-zinc-100 disabled:text-zinc-400" >
                <option key={treasury.currency}>{treasury.currency}</option>
              </select>
            </Labelled>

          </div>
          <Labelled label={`Transfer amount (${treasury.tdnMoniker})`}>
            <span className="w-full px-2 py-1 border rounded">
              {transferAmountInput.toFixed(dq?.displayPrecision)}
            </span>
          </Labelled>
          <Labelled label="Type of receipt">
            <input
              name="receipt-type"
              required
              type="text"
              placeholder="Wire, ACH, etc..."
              className="w-full px-2 py-1 border rounded disabled:bg-zinc-100 disabled:text-zinc-400 invalid:text-error" />
          </Labelled>
          <Labelled label="Details">
            <textarea
              name="receipt-details"
              required
              placeholder="Enter receipt details"
              className="w-full px-2 py-1 border rounded disabled:bg-zinc-100 disabled:text-zinc-400 invalid:text-error" />
          </Labelled>
          <div className="flex flex-row w-full justify-between mt-3">
            <ButtonCancel onClick={() => navigate(-1)} >Back</ButtonCancel>
            <ButtonOk type="submit">Send {treasury.tdnMoniker}</ButtonOk>
          </div>
        </form>
      </div>
    </div>
  </Page>
}